<template>
	<footer class="bg-gradient-bowhead border-0">
		<br>
		<br>
		<div class="container">
			<div class="row align-items-center justify-content-md-between">
				<div class="col-md-6">
					<h4 class="text-white">ABOUT
						<p class="text-white">This is an explorer for the GAHT network that tracks healthy data</p>
					</h4>
				</div>
				<div class="col-md-6">
					<h4 class="text-white">FOLLOW US ON
						<div>
							<base-button tag="a" target="_blank" href="https://twitter.com/bowheadhealth" type="secondary" outline icon="fa fa-twitter" text-color="white" rounded icon-only></base-button>
							<base-button tag="a" target="_blank" href="https://www.facebook.com/bowheadhealth" type="secondary" text-color="white" outline icon="fa fa-facebook-f" rounded icon-only></base-button>
							<base-button tag="a" target="_blank" href="https://www.linkedin.com/company/bowhead-health/" type="secondary" text-color="white" outline icon="fa fa-linkedin-in" rounded icon-only></base-button>
						</div>
					</h4>
				</div>
			</div>
		</div>
		<br>
		<br>
	</footer>
</template>

<script>
export default{}
</script>

<style>
</style>
